import registrationService from '@/api/registration.service'

const actions = {
  candidateRegistration: (context, registrationModel) => {
    let candidateRegistered = new Promise((resolve, reject) => {
      registrationService
        .candidateRegistration(context, registrationModel)
        .then(response => {
          localStorage.setItem('registeredMailId', response.email)
          context.commit('candidateRegistration', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return candidateRegistered
  },
  acceptRecruiterRegistration: (context, registrationModel) => {
    let recruiterRegistered = new Promise((resolve, reject) => {
      registrationService
        .acceptRegistration(context, registrationModel)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return recruiterRegistered
  },
  recruiterRegistration: (context, registrationModel) => {
    let recruiterRegistered = new Promise((resolve, reject) => {
      registrationService
        .postRecruiter(context, registrationModel)
        .then(response => {
          localStorage.setItem('registeredMailId', response.email)
          context.commit('recruiterRegistration', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return recruiterRegistered
  },
  getIndustries: (context, payload) => {
    let industries = new Promise((resolve, reject) => {
      registrationService
        .getIndustryList(context, payload)
        .then(response => {
          context.commit('industryList', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return industries
  },
  resendActivationMail: (context, email) => {
    let sentActivationMail = new Promise((resolve, reject) => {
      registrationService
        .postNewactivationlink(context, email)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return sentActivationMail
  },
  saveProspectInfo: (context, payload) => {
    let prospectInfo = new Promise((resolve, reject) => {
      registrationService
        .saveProspectInfo(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return prospectInfo
  },
  showVideoModal: (context, payload) => {
    context.commit('showVideoModal', payload)
  },
}
export default actions
